import { defineStore } from 'pinia'
import get from 'lodash.get';
import services from '@/services';

export const useL10NStore = defineStore('l10n', {
  state: () => (
    {
      i18n: null,
      messages: {},
      catalogs: {},
      countries: null,
    }),
  getters: {
  },
  actions: {
    seti18n(i18n) {
      this.i18n = i18n;
    },
    setMessages(messages) {
      this.messages = messages;
    },
    hasMessage(key) {
      return get(this.messages, key, null) !== null;
    },
    setCatalog(id, service, locale, messages) {
      services.helpers.set(this.catalogs, `${service}.${id}.${locale}`, messages);
    },
    getCatalog(id, service, locale) {
      return get(this.catalogs, `${service}.${id}.${locale}`);
    },
    setCountries(countries) {
      this.countries = countries;
    }
  },
});
